import React, { useEffect, useState } from 'react';
import './style.scss';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';
import cui from 'components/cui/cui';

const InputDropdown = ({ value, list, name, title, handleOnChange, placeholder, errorMsg, customClass, isTwoLine, disabled }) => {
  const [text, setText] = useState(null);

  useEffect(() => {
    const data = list.filter(item => item.value === value || item.value?.toString() === value.toString())[0];
    setText(data?.text || '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, list]);

  const onSelect = (item) => {
    setText(item.text);
    handleOnChange(item, name);
  }

  return (
    <>
      <div className={`input-dropdown ${customClass || ''} ${isTwoLine ? 'two-line' : ''}`}>
        {title && <span className="input-dropdown__title">{title}</span>}
        <Dropdown disabled={disabled}>
          <Dropdown.Toggle>
            {text || placeholder || list[0]?.text}
          </Dropdown.Toggle>

          <Dropdown.Menu flip={false}>
            {list.map((item, index) => (
              <Dropdown.Item onSelect={() => onSelect(item)} key={index}>
                {item.text}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {!cui.isUndefinedOrNull(errorMsg) &&
        <div className="err-msg">{errorMsg}</div>
      }
    </>
  );
}

InputDropdown.propTypes = {
  list: PropTypes.array,
  handleOnChange: PropTypes.func,
};

InputDropdown.defaultProps = {
  value: '',
  list: [],   
  handleOnChange: () => {},
};

export default React.memo(InputDropdown);
